import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { TranslateModule } from "@ngx-translate/core";
import { OverlayModule } from '@angular/cdk/overlay';
import { MatIconModule } from '@angular/material/icon';
import { A11yModule } from '@angular/cdk/a11y';
import { TableRowOptionsComponent } from "./table-row-options.component";
import { OverflowMenuModule } from "../../../overflow-menu/overflow-menu.module";
import {MatMenuModule} from '@angular/material/menu';
import {ValgInputModule} from '@valg-shared/components/input/input.module';

@NgModule({
  declarations: [ TableRowOptionsComponent ],
  imports: [ 
    CommonModule, 
    TranslateModule, 
    OverlayModule, 
    OverflowMenuModule,
    MatIconModule, 
    MatMenuModule,
    A11yModule,
    ValgInputModule,
  ],
  exports: [ TableRowOptionsComponent ],
})
export class TableRowOptionsModule {}
